module.exports = __webpack_public_path__ + "static/img/banner-curse-default.aaa28c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/curses/banner-curse-default.jpg
// module id = UTXs
// module chunks = 47